import React,{useEffect} from 'react';
import './Homepage.css';
import AOS from 'aos';

const DirectorSection = () => {
    useEffect(() => {
        AOS.init();
        
            window.scrollTo(0, 0)
          
      }, [])
  return (
    <>
    <div className="container-fluid" id='director-section'>
        <div className="row">
            <div className="col" data-aos="fade-right" data-aos-offset="340"  data-aos-duration="1000">
                <img src="img-data/gallery/Photo/director.jpeg" alt="" />
            </div>
            <div className="col right-col" data-aos="fade-left" data-aos-offset="340"  data-aos-duration="1000">
                <h1>Director Says-</h1>
                <hr />
                <p>As the director of "Unique Technologies", I lead with a commitment to innovation, growth, and excellence. Through collaboration and strategic vision, we strive to exceed expectations, empower our team, and achieve sustainable success.</p>
                <h3>-Dharmendra Pandey</h3>
            </div>
        </div>
    </div>
    </>
  )
}

export default DirectorSection
